import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { ConstantsService } from '../../../services/constants.service';
import { CatalogosSatService } from '../../../services/catalogos-sat-service';
import { HelpersService } from '../../../services/tools/helpers.service';

declare var moment;

@Component({
  selector: 'app-modal-facturacion',
  templateUrl: './modal-facturacion.component.html',
  styleUrls: ['./modal-facturacion.component.scss']
})
export class ModalFacturacionComponent implements OnInit {

  public modal: any = null;
  public cxc:any;
  public api_url:string;
  public factura_generada:boolean=false;
  public importeTotalAFacturar: number = 0;
  public loadingCuentas: boolean = false;

  //Modelos
  public cuentasRelacionadas: any[] = [];
  public metodosPago: any[] = [];
  public formasPago: any[] = [];
  public usosCFDI: any[] = [];
  
  //Helpers
  public formaPagoSeleccionado: any = {};
  public metodoPagoSeleccionado: any = {};
  public loading:boolean=false;
  public loadingFormasPago:boolean=false;
  public errors: any = {};
  public emails_facturacion: string = '';
  public usoCFDISeleccionado: any = {};

  @ViewChild('content') private content: TemplateRef<any>;
  @Output() public modalClosed:EventEmitter<any> = new EventEmitter;

  constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
    private constant: ConstantsService, 
    private modalService: NgbModal,
    private satService: CatalogosSatService,
    private helpersService: HelpersService) { }

  ngOnInit() {
    moment.locale('es');
    this.api_url = this.constant.apiURL;
    this.cargarMetodosPago();
    this.cargarFormasPago();
    this.cargarUsosCFDI();
  }

  openModal(cxc){
    this.factura_generada=false;
    this.cxc = cxc;
    this.emails_facturacion = cxc.tipo_cuenta === 'VENTA' ? cxc.cliente_email : cxc.miembro_email;

    let usoCFDI = cxc.tipo_cuenta === 'VENTA' ? cxc.ventas_uso_cfdi : cxc.contrato_uso_cfdi;
    this.seleccionarUsoCFDIDefault(usoCFDI);
    this.seleccionaMetodoPagoDefault(cxc.tipo_cuenta);
    this.seleccionaFormaPagoDefault();

    this.obtenerCuentasPorPagarRelacionadas(this.cxc.id_cuenta_por_cobrar);
    this.modal = this.modalService.open(this.content, { size: 'lg' });
  }

  public generarFactura(){
    this.loading = true;

    let cuentas_por_cobrar = [];
    this.cuentasRelacionadas.forEach(function(cuenta) {
      cuentas_por_cobrar.push(cuenta.id_cuenta_por_cobrar);
    });

    let factura = {
      email_facturacion: this.emails_facturacion,
      payment_form: this.formaPagoSeleccionado.codigo,
      payment_method: this.metodoPagoSeleccionado.id,
      uso_cfdi: this.usoCFDISeleccionado.codigo,
      cuentas_por_cobrar
    };

    this.errors = this.cuentas_por_cobrar_service.validarDatosAFacturar(factura);

    if (Object.entries(this.errors).length > 0) {
      this.loading = false;
      return false;
    }

    this.cuentas_por_cobrar_service.facturarCuentasPorCobrar(factura)
    .subscribe(
      (response)=>{
        this.factura_generada=true;
        this.loading = false;
      },
      (error)=>{
        this.loading = false;
        //alert("ERROR:: "+JSON.stringify(error));
        this.helpersService.httpGlobalError(error,true);
      }
    );
  }

  private obtenerCuentasPorPagarRelacionadas(id_cuenta_por_cobrar: number){
    this.loadingCuentas = true;
    this.cuentas_por_cobrar_service.obtenerCuentasPorCobrarRelacionadas(id_cuenta_por_cobrar)
    .subscribe(
      (response)=>{
        let cuentas = response.json().content;
        this.cuentasRelacionadas = cuentas;

        let importeTotal = 0;
        cuentas.forEach(function(cuenta) {
          
          cuenta.importe_bruto = Number(cuenta.importe_sin_iva);

          //Si le cuenta tiene un incremento anual, sacamos su valor bruto y lo sumamos al importe bruto
          //TODO: En el backend el incremento anual se debería guardar de forma bruta y no neta. 
          //Esto debidó a que la facturación requiere enviar valores brutos, para que los montos cuandren
          if(cuenta.monto_incremento_anual && Number(cuenta.monto_incremento_anual) > 0){
            let incrementoAnualNeto = Number(cuenta.monto_incremento_anual);
            let incrementoAnualBruto = incrementoAnualNeto * (100/116);
            cuenta.importe_bruto += incrementoAnualBruto;
          }

          cuenta.iva_importe_bruto = (cuenta.importe_bruto * 0.16).toFixed(2);
          cuenta.importe_total = (cuenta.importe_bruto * cuenta.cantidad * 1.16).toFixed(2);
          importeTotal += Number(cuenta.importe_total);
        });
        this.importeTotalAFacturar = importeTotal;

        this.loadingCuentas = false;
      },
      (error)=>{
        this.loadingCuentas = false;
        alert("ERROR:: "+JSON.stringify(error));
      }
    );
  }

  public closeModal(reloadParent) {
    this.modal.close();
    if(this.modalClosed){
      this.modalClosed.emit(reloadParent);
    }
  }

  private cargarMetodosPago(){
    let arregloMetodosPago = [
      { id: 'PPD', descripcion: 'PPD - Pago en parcialidades'},
      { id: 'PUE', descripcion: 'PUE - Pago en una sola exhibición'}
    ];

    this.metodosPago = arregloMetodosPago;
    
  }

  private seleccionaMetodoPagoDefault(tipoCuenta){
    let component = this;

    //Seleccionar el método de pago default dependiendo el tipo de cuenta
    switch(tipoCuenta){
      case 'VENTA':
        this.metodosPago.some(metodo => {
          if(metodo.id === CuentasPorCobrarService.METODO_PAGO_DEFAULT_VENTA){
            component.metodoPagoSeleccionado = metodo;
            return true;
          }      
          return false;
        });
        
        break;
      //Caso para RENTAS y MANTENIMIENTOS
      default:
        this.metodosPago.some(metodo => {
          if(metodo.id === CuentasPorCobrarService.METODO_PAGO_DEFAULT){
            component.metodoPagoSeleccionado = metodo;
            return true;
          }      
          return false;
        });

        break;
    }
    
  }

  private cargarFormasPago(){
    this.loadingFormasPago = true;

    this.satService.obtenerFormasPago()
    .subscribe(
      (response)=>{
        let formasPago = response.json().content;
        this.formasPago = formasPago;
        //console.log("this.formasPago:",this.formasPago);
        this.loadingFormasPago = false;
      },
      (error)=>{
        this.loadingFormasPago = false;
        alert("ERROR:: "+JSON.stringify(error));
      }
    );
  }

  private cargarUsosCFDI(){
    this.satService.obtenerUsosCFDI().subscribe((response) => {
        let usosCFDI = response.json().content;
        this.usosCFDI = usosCFDI;
    });
  }

  private seleccionarUsoCFDIDefault(usoCFDIDefault: string){
    //Si la cuenta no tiene definido un uso del cfdi utilizamos el default
    usoCFDIDefault = usoCFDIDefault ? usoCFDIDefault : CuentasPorCobrarService.USO_CFDI_DEFAULT;

    let component = this;
    this.usosCFDI.some(usoDelCFDI => {
      if(usoDelCFDI.codigo === usoCFDIDefault){
        component.usoCFDISeleccionado = usoDelCFDI;
        return true;
      }
      return false;
    });
  }

  private seleccionaFormaPagoDefault(){
    //Seleccionar la forma de pago default
    let component = this;
    this.formasPago.forEach(function(formaPago) {
      if(formaPago.codigo === CuentasPorCobrarService.FORMA_PAGO_DEFAULT){
        component.formaPagoSeleccionado = formaPago;
      }
    });
  }

  public seleccionarUsoCFDI($event){
    this.usoCFDISeleccionado = $event;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/reporte-cxc/modal-facturacion/modal-facturacion.component.ts